export default __webpack_public_path__ + "static/media/basic.ed76fb34.svg";